// test2086
(2086 && 0);
